import { CampaignBlocks } from "@kvix/shared";
import { Container, makeStyles } from "@material-ui/core";
import React, { useContext } from "react";
import { Button } from "../../Inputs";
import { Text } from "../../Primitives";
import { AdminFormInput } from "../admin";
import { AdminCampaignContentContext } from "../context/adminCampaignContentContext";
const useStyles = makeStyles((theme) => ({
    centerBlock: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        backgroundColor: theme.palette.primary.main,
        paddingBottom: "120px"
    },
    titleText: {
        padding: "120px 0 20px 0",
        color: theme.palette.common.black
    },
    subtitles: {
        paddingBottom: "20px",
        color: theme.palette.common.white
    },
    smallSubtitle: {
        color: theme.palette.common.black
    },
    button: {
        color: theme.palette.primary.main,
        marginBottom: "20px",
        padding: "0 20px 0 20px",
        height: "44px",
        borderRadius: "30px",
        textTransform: "capitalize",
        background: theme.palette.common.white,
        "&:active": {
            animation: "$scaleButton linear 300ms "
        },
        "&:hover": {
            background: theme.palette.common.white
        }
    },
    "@keyframes scaleButton": {
        "0%": {
            transform: "scale(1)"
        },
        "50%": {
            transform: "scale(1.1)"
        },
        "100%": {
            transform: "scale(1)"
        }
    }
}));
export class CtaWithTextBlock {
    constructor() {
        this.defaultStructure = {
            name: CampaignBlocks.CtaWithTextBlock,
            titles: [""],
            subTitles: [""],
            buttons: [{ text: "" }],
            texts: [""]
        };
        this.Render = (props) => {
            const { block, campaignContext } = props;
            const classes = useStyles();
            const onClick = () => {
                campaignContext === null || campaignContext === void 0 ? void 0 : campaignContext.openModal(campaignContext);
            };
            return (React.createElement("div", { className: classes.centerBlock },
                React.createElement(Container, { maxWidth: "md" },
                    React.createElement(Text, { className: classes.titleText, variant: "h1" }, block.titles[0]),
                    React.createElement(Text, { variant: "h4", className: classes.subtitles }, block.subTitles[0]),
                    React.createElement(Button, { className: classes.button, onClick: onClick }, block.buttons[0].text),
                    React.createElement(Text, { variant: "h6", className: classes.smallSubtitle }, block.texts[0]))));
        };
        this.Compose = (props) => {
            const { block } = props;
            const { updateContent } = useContext(AdminCampaignContentContext);
            const titleOnChange = (event) => {
                block.titles[0] = event.target.value;
                updateContent(block);
            };
            const subtitleOnChange = (event) => {
                block.subTitles[0] = event.target.value;
                updateContent(block);
            };
            const textOnChange = (event) => {
                block.texts[0] = event.target.value;
                updateContent(block);
            };
            const buttonTextOnChange = (event) => {
                block.buttons[0].text = event.target.value;
                updateContent(block);
            };
            return (React.createElement(React.Fragment, null,
                React.createElement(AdminFormInput, { name: "title", label: "Title", onChange: titleOnChange, required: true, value: block.titles[0] }),
                React.createElement(AdminFormInput, { name: "subtitle", label: "Subtitle", onChange: subtitleOnChange, required: true, value: block.subTitles[0] }),
                React.createElement(AdminFormInput, { name: "buttonText", label: "Button Text", onChange: buttonTextOnChange, required: true, value: block.buttons[0].text }),
                React.createElement(AdminFormInput, { name: "text", label: "Text", onChange: textOnChange, required: true, value: block.texts[0] })));
        };
    }
}
//# sourceMappingURL=CtaWithTextBlock.js.map